.CTABanner {
  position: relative;
  margin: 0 auto;
  display: flex;
  max-width: var(--brand-breakpoint-xlarge);
  width: 100%;
}

.CTABanner--shadow::before {
  content: '';
  position: absolute;
  inset: var(--base-size-16);
  filter: blur(var(--base-size-96));
  transform: translateZ(0);
  background: linear-gradient(
    to right,
    var(--brand-CTABanner-shadow-color-start),
    var(--brand-CTABanner-shadow-color-end)
  );
}

.CTABanner-grid {
  row-gap: 0;
  --brand-Grid-spacing-row: 0;
  padding-inline: 0;
}

.CTABanner-grid-column--primary {
  display: flex;
  align-items: center;
}

.CTABanner-grid-column--secondary {
  display: flex;
  align-items: center;
  justify-content: center;
}

.CTABanner--variant-minimal .CTABanner-grid-column--secondary {
  justify-content: flex-end;
}

.CTABanner--variant-balanced .CTABanner-grid-column--secondary {
  justify-content: flex-start;
}

@media screen and (min-width: 63.25rem) {
  .CTABanner--variant-balanced .CTABanner-grid-column--secondary {
    justify-content: flex-end;
  }
}

/* Stack on narrow viewports */
@media screen and (max-width: 63.24rem) {
  .CTABanner--variant-minimal .CTABanner-grid-column--secondary {
    justify-content: flex-start;
  }

  .CTABanner--variant-balanced .CTABanner-grid-column--secondary {
    order: -1;
    margin-block-start: 0;
  }

  .CTABanner--variant-balanced .CTABanner-grid-column--primary {
    margin-block-start: var(--base-size-24);
  }

  .CTABanner-grid-column--secondary {
    margin-block-start: var(--base-size-24);
  }
}

.CTABanner-outer-container--border {
  border-block: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.CTABanner-container {
  padding: var(--base-size-64) var(--base-size-32);
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
}

.CTABanner--variant-balanced .CTABanner-container {
  padding-inline: var(--base-size-20);
  padding-block: var(--base-size-32);
}

.CTABanner--variant-minimal .CTABanner-container {
  padding-inline: var(--base-size-20);
  padding-block: var(--base-size-40);
}

.CTABanner-content {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-16);
  align-items: flex-start;
  max-width: 800px;
  margin: 0 auto;
}

.CTABanner--variant-minimal .CTABanner-content {
  gap: 0;
}

.CTABanner--variant-balanced .CTABanner-content,
.CTABanner--variant-minimal .CTABanner-content {
  max-width: 576px;
  margin: 0;
}

.CTABanner-container--background {
  background-repeat: no-repeat;
  background-color: var(--brand-CTABanner-bgColor);
  background-image: var(--brand-CTABanner-narrow-background-image-src, var(--brand-CTABanner-background-image-src));
  background-size: var(--brand-CTABanner-narrow-background-image-size, var(--brand-CTABanner-background-image-size));

  background-position: var(
    --brand-CTABanner-narrow-background-image-position,
    var(--brand-CTABanner-background-image-position, center)
  );
}

.CTABanner-container--border {
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.CTABanner-container--border-gridlines {
  border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  margin-inline: auto;
  max-width: 534px; /* To match tablet for river */
}

.CTABanner-content--center {
  align-items: center;
  text-align: center;
}

.CTABanner-description {
  margin-bottom: var(--base-size-16);
}

/* Medium breakpoint and up */
@media screen and (min-width: 48rem) {
  .CTABanner-container {
    padding: var(--base-size-80) var(--base-size-36);
  }

  .CTABanner--variant-balanced .CTABanner-container {
    padding: var(--base-size-36);
    padding-block-end: var(--base-size-48);
  }

  .CTABanner--variant-minimal .CTABanner-container {
    padding: var(--base-size-36);
    padding-block: var(--base-size-48);
  }

  .CTABanner-container--background {
    background-color: var(--brand-CTABanner-regular-background-color, var(--brand-CTABanner-background-color));
    background-image: var(--brand-CTABanner-regular-background-image-src, var(--brand-CTABanner-background-image-src));
    background-size: var(--brand-CTABanner-regular-background-image-size, var(--brand-CTABanner-background-image-size));
    background-position: var(
      --brand-CTABanner-regular-background-image-position,
      var(--brand-CTABanner-background-image-position)
    );
  }
}

/* Large breakpoint and up */
@media screen and (min-width: 63.25rem) {
  .CTABanner-content {
    gap: var(--base-size-24);
  }
  .CTABanner--variant-balanced .CTABanner-content {
    gap: var(--base-size-32);
  }
  .CTABanner-container {
    padding: var(--base-size-96) var(--base-size-64);
    max-width: 100%;
  }

  .CTABanner--variant-balanced .CTABanner-container {
    padding: var(--base-size-64);
  }

  .CTABanner--variant-minimal .CTABanner-container {
    padding: var(--base-size-64);
  }
}

/* Wide */
@media screen and (min-width: 80rem) {
  .CTABanner-container--background {
    background-color: var(--brand-CTABanner-wide-background-color, var(--brand-CTABanner-background-color));
    background-image: var(--brand-CTABanner-wide-background-image-src, var(--brand-CTABanner-background-image-src));
    background-size: var(--brand-CTABanner-wide-background-image-size, var(--brand-CTABanner-background-image-size));

    background-position: var(
      --brand-CTABanner-wide-background-image-position,
      var(--brand-CTABanner-background-image-position)
    );
  }
}

.CTABanner-image {
  width: 100%;
  height: auto;
}

.CTABanner--variant-balanced .CTABanner-image {
  max-width: 476px;
  width: 100%;
  height: auto;
}

@media screen and (min-width: 63.25rem) {
  .CTABanner--variant-balanced .CTABanner-image {
    max-width: 100%;
    height: auto;
  }

  .CTABanner--variant-balanced .CTABanner-grid-column--primary:has(.CTABanner-logo) {
    align-items: stretch;
  }

  .CTABanner--variant-balanced .CTABanner-grid-column--primary:has(.CTABanner-logo) > .CTABanner-content {
    flex: 1;
  }

  .CTABanner--variant-balanced .CTABanner-content:has(> .CTABanner-logo) > .CTABanner-logo + * {
    margin-block-start: auto;
  }
}

.CTABanner-logo {
  display: flex;
  align-items: center;
  gap: var(--base-size-8);
  width: 100%;
  padding-block-end: var(--base-size-32);
  border-block-end: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.CTABanner-logo > svg,
.CTABanner-logo > img {
  height: var(--base-size-40);
  width: auto;
  display: block;
}

.CTABanner--variant-default .CTABanner-logo {
  width: auto;
  padding-block-end: 0;
  border-block-end: none;
}

.CTABanner--variant-minimal .CTABanner-logo {
  margin-block-end: var(--base-size-24);
}

.CTABanner-link {
  align-self: auto;
}

/*
 * We use a custom token here because text-emphasized doesn't reach 4.5 contrast
 * against the default banner bgColor in light mode.
 */
.CTABanner-heading b {
  color: var(--brand-CTABanner-color-heading-emphasis);
  font-weight: inherit;
}

.CTABanner-heading code,
.CTABanner-description code {
  font-size: inherit;
  font-family: var(--brand-fontStack-monospace);
  background-color: var(--brand-color-canvas-default);
  padding: 0 var(--base-size-4) 0;
  margin-inline: var(--base-size-2);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
  border-radius: var(--brand-borderRadius-small);
  box-shadow: var(--brand-borderWidth-thin) var(--brand-borderWidth-thin) 0 0 var(--brand-color-border-default);
}

.CTABanner--bgColor-default .CTABanner-heading code,
.CTABanner--bgColor-default .CTABanner-description code {
  background-color: var(--brand-color-canvas-subtle);
}

.CTABanner-description code {
  padding: 0 var(--base-size-4) 0;
}

.CTABanner-heading.CTABanner-heading:has(code) {
  line-height: calc(1lh * 2);
}

@media screen and (min-width: 63.25rem) {
  .CTABanner--variant-balanced .CTABanner-heading.CTABanner-heading:has(code) {
    line-height: calc(1lh * 2.8);
  }
}

.CTABanner--variant-minimal .CTABanner-heading.CTABanner-heading:has(code) {
  line-height: calc(1lh * 1.9);
}

.CTABanner-description.CTABanner-description:has(code) {
  line-height: calc(1lh * 1.25);
}
